import { useState, useRef } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import DotGrid from './DotGrid'

const ACCOUNTS = [
  { email: 'sara@mercygeneral.com', name: 'Sara Chen', password: 'demo1234' },
  { email: 'emilio@its.jnj.com',    name: 'Emilio Reyes', password: 'demo1234' },
]

export default function LoginPage({ onLogin }) {
  const [email, setEmail] = useState('sara@mercygeneral.com')
  const [password, setPassword] = useState('')
  const [focused, setFocused] = useState(null)
  const [showDropdown, setShowDropdown] = useState(false)
  const emailRef = useRef(null)

  const handleSubmit = (e) => {
    e.preventDefault()
    const match = ACCOUNTS.find(a => a.email === email) || ACCOUNTS[0]
    onLogin(match)
  }

  const selectAccount = (account) => {
    setEmail(account.email)
    setPassword(account.password)
    setShowDropdown(false)
    emailRef.current?.blur()
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      style={{
        width: '100vw', height: '100vh',
        background: '#1C1C1C',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        position: 'relative', overflow: 'hidden',
      }}
    >
      {/* Dot grid background */}
      <div style={{ position: 'absolute', inset: 0, opacity: 0.85 }}>
        <DotGrid />
      </div>

      {/* Card */}
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1], delay: 0.15 }}
        style={{
          position: 'relative', zIndex: 1,
          width: 360,
          background: 'rgba(0,0,0,0.55)',
          borderRadius: 12,
          padding: '36px 32px 32px',
          display: 'flex', flexDirection: 'column', gap: 24,
          boxShadow: '0 0 0 1px rgba(255,255,255,0.07), 0 32px 64px rgba(0,0,0,0.5)',
        }}
      >
        {/* Brand */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          style={{ display: 'flex', flexDirection: 'column', gap: 6 }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
            <div style={{
              width: 28, height: 28, borderRadius: 7,
              background: '#EB1700',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <BoltIcon />
            </div>
            <span style={{ fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.5)', letterSpacing: '0.12em', textTransform: 'uppercase' }}>
              J&J Agent Platform
            </span>
          </div>
          <h1 style={{ fontSize: 24, fontWeight: 600, color: '#FFFFFF', margin: 0, lineHeight: 1.2 }}>
            Welcome back
          </h1>
          <p style={{ fontSize: 13, color: '#A39992', margin: 0 }}>
            Sign in to your account
          </p>
        </motion.div>

        {/* Form */}
        <motion.form
          onSubmit={handleSubmit}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4, delay: 0.45 }}
          style={{ display: 'flex', flexDirection: 'column', gap: 12 }}
        >
          {/* Email field with dropdown */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
            <label style={labelStyle}>Email</label>
            <div style={{ position: 'relative' }}>
              <motion.input
                ref={emailRef}
                animate={{ boxShadow: focused === 'email' ? '0 0 0 1px rgba(255,255,255,0.25)' : '0 0 0 1px rgba(255,255,255,0.08)' }}
                transition={{ duration: 0.15 }}
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                onFocus={() => { setFocused('email'); setShowDropdown(true) }}
                onBlur={() => { setFocused(null); setTimeout(() => setShowDropdown(false), 150) }}
                style={inputStyle}
                autoComplete="off"
              />

              <AnimatePresence>
                {showDropdown && (
                  <motion.div
                    initial={{ opacity: 0, y: -4, scale: 0.98 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    exit={{ opacity: 0, y: -4, scale: 0.98 }}
                    transition={{ duration: 0.15, ease: 'easeOut' }}
                    style={{
                      position: 'absolute', top: 'calc(100% + 6px)', left: 0, right: 0,
                      background: '#1A1A1A',
                      borderRadius: 8,
                      boxShadow: '0 0 0 1px rgba(255,255,255,0.1), 0 8px 32px rgba(0,0,0,0.6)',
                      overflow: 'hidden',
                      zIndex: 10,
                    }}
                  >
                    <div style={{ padding: '6px 10px 4px', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
                      <span style={{ fontSize: 9, fontWeight: 700, color: 'rgba(255,255,255,0.3)', letterSpacing: '0.1em', textTransform: 'uppercase' }}>
                        Recent
                      </span>
                    </div>
                    {ACCOUNTS.map((account) => (
                      <motion.button
                        key={account.email}
                        type="button"
                        onMouseDown={() => selectAccount(account)}
                        whileHover={{ background: 'rgba(255,255,255,0.06)' }}
                        style={{
                          width: '100%', padding: '9px 12px',
                          background: 'transparent', border: 'none',
                          cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 10,
                          textAlign: 'left',
                        }}
                      >
                        <div style={{
                          width: 26, height: 26, borderRadius: '50%',
                          background: 'rgba(255,255,255,0.08)',
                          display: 'flex', alignItems: 'center', justifyContent: 'center',
                          flexShrink: 0,
                        }}>
                          <span style={{ fontSize: 10, fontWeight: 700, color: 'rgba(255,255,255,0.5)' }}>
                            {account.name.charAt(0)}
                          </span>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                          <span style={{ fontSize: 12, fontWeight: 600, color: '#FFFFFF' }}>{account.name}</span>
                          <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)' }}>{account.email}</span>
                        </div>
                      </motion.button>
                    ))}
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </div>

          {/* Password field */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
            <label style={labelStyle}>Password</label>
            <motion.input
              animate={{ boxShadow: focused === 'password' ? '0 0 0 1px rgba(255,255,255,0.25)' : '0 0 0 1px rgba(255,255,255,0.08)' }}
              transition={{ duration: 0.15 }}
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              onFocus={() => setFocused('password')}
              onBlur={() => setFocused(null)}
              placeholder="••••••••"
              style={inputStyle}
            />
          </div>

          <motion.button
            type="submit"
            whileHover="hover"
            initial="rest"
            whileTap={{ scale: 0.97 }}
            variants={{ rest: {}, hover: { filter: 'brightness(1.1)' } }}
            style={{
              marginTop: 4,
              height: 42, borderRadius: 8,
              background: '#EB1700', border: 'none',
              color: '#FFFFFF', fontSize: 13, fontWeight: 600,
              cursor: 'pointer', fontFamily: 'inherit',
              position: 'relative', overflow: 'hidden',
            }}
          >
            <motion.span
              variants={{ rest: { x: '-110%' }, hover: { x: '210%' } }}
              transition={{ duration: 0.5, ease: 'easeInOut' }}
              style={{
                position: 'absolute', inset: 0, width: '60%',
                background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
                pointerEvents: 'none', skewX: '-12deg',
              }}
            />
            Sign in
          </motion.button>
        </motion.form>

      </motion.div>
    </motion.div>
  )
}

function BoltIcon() {
  return (
    <svg width="10" height="12" viewBox="0 0 10 12" fill="none">
      <path d="M6 1L1 7h4l-1 4 5-6H5l1-4z" fill="white" />
    </svg>
  )
}

const labelStyle = {
  fontSize: 11, fontWeight: 600,
  color: 'rgba(255,255,255,0.45)',
  letterSpacing: '0.06em', textTransform: 'uppercase',
}

const inputStyle = {
  height: 40, borderRadius: 8,
  background: 'rgba(255,255,255,0.05)',
  border: 'none', outline: 'none',
  color: '#FFFFFF', fontSize: 13,
  padding: '0 12px', fontFamily: 'inherit',
  width: '100%', boxSizing: 'border-box',
}
